import { DateTime } from "luxon";

export const messagesTypeFields = [
  {
    id: "bookingConfirmation",
    label: "Booking Confirmation",
    helperText:
      "This message will be sent to the patient after the appointment is confirmed",
  },
  {
    id: "bookingReminder",
    label: "Booking Reminder",
    helperText:
      "This message will be sent to the patient 2 hours before the appointment",
  },
  {
    id: "patientCancellation",
    label: "Patient Cancellation",
    helperText:
      "This message will be sent to the patient if they cancel the appointment",
  },
  {
    id: "clinicCancellation",
    label: "Clinic Cancellation",
    helperText:
      "This message will be sent to the patient if the clinic cancels the appointment",
  },
  {
    id: "patientReschedule",
    label: "Patient Reschedule",
    helperText:
      "This message will be sent to the patient if the patient reschedules the appointment",
  },
  {
    id: "clinicReschedule",
    label: "Clinic Reschedule",
    helperText:
      "This message will be sent to the patient if the clinic reschedules the appointment",
  },
];

export const messageVariables = [
  { name: "firstName", label: "First Name" },
  { name: "lastName", label: "Last Name" },
  { name: "date", label: "Date" },
  { name: "time", label: "Time" },
  { name: "clinicName", label: "Clinic Name" },
  { name: "clinicAddress", label: "Clinic Address" },
];

const variableNames = messageVariables.map((v) => v.name).join("|");

export const variableNameRegex = new RegExp(
  `{{\\s*(${variableNames})\\s*}}`,
  "g"
);

const previewData = {
  firstName: "John",
  lastName: "Doe",
  date: {
    en: DateTime.now()
      .plus({ days: 1 })
      .setLocale("en")
      .toFormat("MMMM dd, yyyy"),
    fr: DateTime.now()
      .plus({ days: 1 })
      .setLocale("fr")
      .toFormat("dd MMMM yyyy"),
  },
  time: {
    en: DateTime.now().setLocale("en").toFormat("hh:mm a"),
    fr: DateTime.now().setLocale("fr").toFormat("HH:mm"),
  },
  clinicName: {
    en: "Health Clinic",
    fr: "Clinique de Santé",
  },
  clinicAddress: {
    en: "123 Health St, Wellness City",
    fr: "123 Rue de la Santé, Ville de Bien-être",
  },
};

export const findPreviewDataValue = (fieldId, lang, clinic = null) => {
  if (!fieldId || !lang) return "";

  // Use the clinic data if available
  if (clinic && (fieldId === "clinicName" || fieldId === "clinicAddress")) {
    const fieldMap = {
      clinicName: {
        en: clinic.name,
        fr: clinic.french?.name,
      },
      clinicAddress: {
        en: clinic.address,
        fr: clinic.french?.address,
      },
    };
    return fieldMap[fieldId][lang] || previewData[fieldId][lang];
  }

  const value = previewData[fieldId];
  return typeof value === "object" && value !== null ? value[lang] : value;
};
